import state from './moduleBlacklistState.js'
import mutations from './moduleBlacklistMutations.js'
import actions from './moduleBlacklistActions.js'
import getters from './moduleBlacklistGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
